<div class="middle-box text-center animated fadeInDown" style="min-height: 80vh;">

  <div id="pnlNotFound">

    <h1>404</h1>
    <h3 class="font-bold">Page Not Found</h3>
    <div class="error-desc">
      Sorry, but the page you are looking for has not been found. Try checking the URL for error, then hit the refresh
      button on your browser.<br><br>
      If you continue to encounter this error please contact a system administrator.<br>
    </div>

  </div>

</div>